
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"18","viewBox":"0 0 14 18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.537 15.667H2.463c-.255 0-.463-.187-.463-.417V2.75c0-.23.208-.417.463-.417h3.704v3.459c0 1.31 1.014 2.375 2.261 2.375H12v7.083c0 .23-.208.417-.463.417zm.17-9.167H8.429c-.328 0-.595-.318-.595-.708V2.333h.094l3.78 4.167zm1.743-.56l-4.536-5a.832.832 0 00-.618-.273H2.463c-1.175 0-2.13.935-2.13 2.083v12.5c0 1.148.956 2.083 2.13 2.083h9.074c1.174 0 2.13-.935 2.13-2.083V6.5a.833.833 0 00-.217-.56z","fill":"#4D4D4D"}})])
          )
        }
      }
    